<template>
  <div class="cmp-property-radio">
    <ws-radio-list
      v-if="options.length"
      v-model="model"
      :show-selected-only="!inEdit"
      selected-bolded
      without-delimiter
      :no-spacing-x="noSpacingX"
      :no-spacing-y="noSpacingY"
      small
      uid-prop="type"
      mode="item"
      :items="options"
    >
      <template v-slot="scope">
        <price-period
          class="float-right"
          individual
          :plain="!scope.isSelected"
          :price="inEdit ? scope.item.price : model.price"
          :prices="inEdit ? scope.item.prices : model.prices"
          :period="period"
          :hide-free="hideFree"
        />
        <span class="type-label">{{
          $t(path + '.' + scope.item.type + '.label')
        }}</span>
      </template>
      <template v-slot:info="scope">
        <small
          v-if="i18next.i18next.exists(path + '.' + scope.item.type + '.info')"
          class="q-mt-xs q-pl-sm inline-block"
          :class="inEdit ? 'q-ml-lg' : 'q-ml-xs'"
        >
          {{ $t(path + '.' + scope.item.type + '.info') }}
          <a v-if="link" class="ws-link" :href="link" target="_blank">{{
            $t(path + '.' + scope.item.type + '.link')
          }}</a>
        </small>
      </template>
    </ws-radio-list>
    <template v-else>
      <q-skeleton
        type="QRange"
        animation="fade"
        height="60px"
        class="q-mt-md"
      />
      <q-skeleton
        type="QRange"
        animation="fade"
        height="60px"
        class="q-mt-md"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { QSkeleton } from 'quasar';

import { cloneDeep } from 'lodash-es';
import WsRadioList from '@/components/WsRadioList.vue';
import PricePeriod from '@/components/PricePeriod.vue';
import { useI18n } from '@odin/services';

@Component({
  components: {
    QSkeleton,
    WsRadioList,
    PricePeriod,
  },
})
export default class PropertyRadio extends Vue {
  @Prop(String)
  readonly path!: string;
  @Prop({ default: () => ({}) })
  readonly value!: any;
  @Prop({ default: () => [] })
  readonly options!: any;
  @Prop({ default: 12 })
  readonly period!: any;
  @Prop(String)
  readonly link!: string;
  @Prop(Boolean)
  readonly inEdit!: boolean;
  @Prop(Boolean)
  readonly hideFree!: boolean;
  @Prop({ default: true })
  readonly noSpacingX!: boolean;
  @Prop({ default: true })
  readonly noSpacingY!: boolean;

  i18next = useI18n();

  get model() {
    return cloneDeep(this.value);
  }
  set model(model: any) {
    if (!this.inEdit) {
      // not to change model with custom price, different
      // then in options https://loopiagroup.atlassian.net/browse/PNO-2174
      return;
    }
    this.$emit('input', model);
  }
}
</script>

<style lang="scss" scoped>
.ws-radio-list {
  .cmp-price-period {
    height: 1px; // fixing broken row height
  }

  .type-label {
    display: block;
    margin-top: 6px;
    font-weight: bold;
    color: $ws-ui-primary;
  }
}
</style>
